import Icon from '../components/Icon.vue'

Icon.register({
  'id-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32c26.5 0 48 21.5 48 48v16h-576v-16c0-26.5 21.5-48 48-48h480zM0 432v-304h576v304c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48zM352 200v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8zM352 264v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8zM352 328v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8zM176 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zM67.1 396.2c-3.2 9.8 5.2 19.8 15.6 19.8h186.6c10.4 0 18.8-9.9 15.6-19.8-8.4-25.7-32.5-44.2-60.9-44.2h-8.2c-12.2 5.1-25.7 8-39.8 8s-27.5-2.9-39.8-8h-8.2c-28.4 0-52.5 18.5-60.9 44.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/id-card.js
// module id = 1480
// module chunks = 0